import css from './ItemImages.module.scss'
import Dropzone from 'react-dropzone'
import S3 from 'react-aws-s3'
import { toast } from 'react-toastify'

import { useEffect, useState } from 'react'
import { handleToast } from 'src/slices/utils'

window.Buffer = window.Buffer || require('buffer').Buffer

function Croppedimages({ images, removeImage, addImage, setImages, divStyles }) {
	const config = {
		bucketName: 'carty-app',
		region: 'us-east-1',
		accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
		secretAccessKey: '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',
		s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
	}

	const handleImageDrop = acceptedFiles => {
		if (!['image/jpeg', 'image/png'].includes(acceptedFiles[0]?.type)) {
			toast.warning('Only .png and .jpg files are accepted')
			return
		}

		const ReactS3Client = new S3(config)

		const uploadImage = ReactS3Client.uploadFile(acceptedFiles[0], acceptedFiles[0].name).then(
			data => {
				addImage(data.location)
			}
		)

		handleToast(uploadImage, {
			isSuccess: { message: 'Image Uploaded!' },
			isError: { message: 'Image could not be uploaded, please try again.' },
			isLoading: { message: `Uploading...` },
		})
	}
	const setPrimaryImage = primaryImage => {
		setImages([primaryImage, ...images.filter(image => image != primaryImage)])
	}
	return (
		<div className={css['wrapper']}>
			<h3 style={{ marginBottom: '8px' }}>Images</h3>
			<div
				className={css['slider']}
				style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
				{images?.length > 0 && (
					<div
						style={divStyles}
						className={css['image']}>
						<img
							height='120px'
							width='120px'
							src={images[0]}
							className={css['first']}
						/>
						<i
							className={`fa fa-trash-alt ${css['icon']}`}
							onClick={() => removeImage(images[0])}
						/>
					</div>
				)}
				{images?.map((image, index) => {
					return (
						index > 0 && (
							<div
								style={divStyles}
								className={css['image']}
								onClick={() => setPrimaryImage(image)}>
								<img
									height='120px'
									width='120px'
									src={image}
								/>
								<i
									className={`fa fa-trash-alt ${css['icon']}`}
									onClick={e => {
										removeImage(image)
										e.stopPropagation()
										e.defaultPrevented()
									}}
								/>
							</div>
						)
					)
				})}
				<Dropzone
					accept={['image/jpeg', 'image/png']}
					onDrop={acceptedFiles => handleImageDrop(acceptedFiles)}>
					{({ getRootProps, getInputProps }) => (
						<div
							{...getRootProps()}
							className={css['upload']}>
							<input {...getInputProps()} />
							<i className='fa fa-plus' />
							<span>Upload</span>
						</div>
					)}
				</Dropzone>
			</div>
		</div>
	)
}

export default Croppedimages
